import React from 'react';
import ReactSwitch from 'react-switch';

type Props = {
  onChange: () => void;
  value: boolean;
};

const Switch = (props: Props) => {
  const { onChange, value } = props;

  return (
    <ReactSwitch
      checked={value}
      onChange={onChange}
      handleDiameter={28}
      height={32}
      width={51}
      onColor="#44db5d"
      activeBoxShadow="none"
      boxShadow="rgba(0, 0, 0, 0.3) 0px 2px 4px"
      uncheckedIcon={false}
      checkedIcon={false}
    />
  );
};

export default Switch;
